/* eslint-disable react/jsx-no-bind */
import { Button, Modal, Result } from 'antd';
import React from 'react';

export function ModalQuestionEmptyWithoutObservation({
  isModalOpen,
  setIsModalOpen,
}) {
  return (
    <Modal
      title="Existem questões em branco sem observação"
      open={isModalOpen}
      footer={null}
      onCancel={() => setIsModalOpen(false)}
      width={700}
    >
      <Result
        status="warning"
        title="Existem questões em branco sem observação"
      />

      <div style={{ textAlign: 'center', marginTop: 50 }}>
        <Button type="primary" onClick={() => setIsModalOpen(false)}>
          Corrigir
        </Button>
      </div>
    </Modal>
  );
}
